module.exports = __webpack_public_path__ + "img/enroll.fb078a8e.svg";